/* import __COLOCATED_TEMPLATE__ from './feed-items.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();